<template>
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
<!--          <a-col :span="8">-->
<!--            <a-form-item label="合同编码" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="8">
            <!--label="饲养天数"-->
            <a-form-item :label="$t('label.age')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['breedCycleDays', validatorRules.breedCycleDays]" :placeholder="$t('label.pleaseEnterAge')" style="width: 92%"/> {{ $t('label.day') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="合同数量"-->
            <a-form-item :label="$t('label.numberOfContracts')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number @change="planBreedQtyChange" v-decorator="['planBreedQty', validatorRules.planBreedQty]" :placeholder="$t('label.pleaseEnterTheNumberOfContracts')" style="width: 92%"/> {{ $t('label.only') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-has="'buffer7'" label="xxx" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer7']" placeholder="xxx"></a-input>
            </a-form-item>
          </a-col>
          <a-divider style="margin-bottom: 32px"/>
<!--          <a-col :span="6">-->
<!--            <a-statistic  value="上限"  :labelCol="labelCol" :wrapperCol="wrapperCol"/>-->
<!--          </a-col>-->
<!--          <a-col :span="8">-->
<!--            <a-statistic  value="下限"  :labelCol="labelCol" :wrapperCol="wrapperCol"/>-->
<!--          </a-col>-->
<!--          <a-col :span="8">-->
<!--            <a-statistic  value="标准" :labelCol="labelCol" :wrapperCol="wrapperCol"/>-->
<!--          </a-col>-->
          <a-col :span="8">
            <!--label="成活率上限"-->
            <a-form-item :label="$t('label.maximumLivability')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdSurvivalUp', validatorRules.stdSurvivalUp]" :placeholder="$t('label.pleaseEnterTheUpperLimitOfLivability')" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="成活率下限"-->
            <a-form-item :label="$t('label.minimumLivability')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdSurvivalDown', validatorRules.stdSurvivalDown]" :placeholder="$t('label.pleaseEnteTheMinimumLivability')" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="标准成活率"-->
            <a-form-item :label="$t('label.wtandardLivability')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdSurvivalAvg', validatorRules.stdSurvivalAvg]" :placeholder="$t('label.pleaseEnterTheStandardLivability')" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-has="'stdSecSurvivalUp'" label="次级成活率上限" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdSecSurvivalUp']" placeholder="请输入次级标准成活率上限" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-has="'stdSecSurvivalDown'" label="次级成活率下限" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdSecSurvivalDown']" placeholder="请输入次级标准成活率下限" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item v-has="'stdSecSurvivalAvg'" label="次级成活率" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdSecSurvivalAvg']" placeholder="请输入次级标准成活率" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="体重上限"-->
            <a-form-item :label="$t('label.weightLimit')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdWeightUp', validatorRules.stdWeightUp]" :placeholder="$t('label.pleaseEnterTheUpperLimitOfStandardWeight')" style="width: 84%"/> Kg/{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="体重下限"-->
            <a-form-item :label="$t('label.lowerWeightLimit')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdWeightDown', validatorRules.stdWeightDown]" :placeholder="$t('label.pleaseEnterTheLowerStandardWeightLimit')" style="width: 84%"/> Kg/{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="标准体重"-->
            <a-form-item  :label="$t('label.standardWeight')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdWeightAvg', validatorRules.stdWeightAvg]" :placeholder="$t('label.pleaseEnterStandardWeight')" style="width: 84%"/> Kg/{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="均匀度上限"-->
            <a-form-item :label="$t('label.uniformityUpperLimit')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdEvennessUp']" :placeholder="$t('label.pleaseEnterTheUpperLimitOfStandardEvenness')" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="均匀度下限"-->
            <a-form-item :label="$t('label.lowerLimitOfUniformity')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdEvennessDown']" :placeholder="$t('label.pleaseEnterTheLowerLimitOfStandardUniformity')" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="标准均匀度"-->
            <a-form-item :label="$t('label.standardUniformity')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdEvennessAvg']" :placeholder="$t('label.pleaseEnterTheStandardUniformity')" style="width: 84%"/>   %
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="耗用量上限"-->
            <a-form-item :label="$t('label.upperLimitOfConsumption')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdConsumeUp', validatorRules.stdConsumeUp]" :placeholder="$t('label.pleasEnterTheUpperLimitOfConsumptionPerUnit')" style="width: 84%"/> Kg/{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="耗用量下限"-->
            <a-form-item :label="$t('label.lowerLimitOfConsumption')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdConsumeDown', validatorRules.stdConsumeDown]" :placeholder="$t('label.pleaseEnterTheLowerLimitOfConsumptionPerUnit')" style="width: 84%"/> Kg/{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="标准耗用量"-->
            <a-form-item :label="$t('label.standardConsumption')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdConsumeAvg', validatorRules.stdConsumeAvg]" :placeholder="$t('label.pleaseEnterTheConsumptionAmountPerUnit')" style="width: 84%"/> Kg/{{ $t('label.feather') }}
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="料肉比上限"-->
            <a-form-item :label="$t('label.upperLimitOfMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdFeedMeatUp', validatorRules.stdFeedMeatUp]" :placeholder="$t('label.pleaseEnterTheUpperLimitOfStandardMeatRatio')" style="width: 84%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="料肉比下限"-->
            <a-form-item :label="$t('label.lowerLimitOfMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdFeedMeatDown', validatorRules.stdFeedMeatDown]" :placeholder="$t('label.pleaseEnterTheLowerLimitOfStandardMeatRatio')" style="width: 84%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--label="标准料肉比"-->
            <a-form-item :label="$t('label.standardMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['stdFeedMeatAvg', validatorRules.stdFeedMeatAvg]" :placeholder="$t('label.pleaseEnterTheStandardMeatRatio')" style="width: 84%"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'ContractBreedStandardForm',
    components: {
      JFormContainer,
    },
    props:{
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      // 当前table对应的数据表名
      tableName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        mainTable: 'efs_md_contract_detail',
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
          breedCycleDays: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterAge')},
              { pattern: /^-?\d+$/, message: this.$t('label.pleaseEnterAWholeNumber')},
            ]
          },
          planBreedQty: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheNumberOfContracts')},
              { pattern: /^[1-9]\d*$/, message: this.$t('label.pleaseEnterAWholeNumber')},
            ]
          },
          stdSurvivalUp: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheUpperLimitOfLivability')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdSurvivalDown: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnteTheMinimumLivability')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdSurvivalAvg: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheStandardLivability')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          // stdSecSurvivalUp: {
          //   rules: [
          //     { required: true, message: '请输入次级标准成活率!'},
          //     { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
          //   ]
          // },
          // stdSecSurvivalDown: {
          //   rules: [
          //     { required: true, message: '请输入次级标准成活率!'},
          //     { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
          //   ]
          // },
          // stdSecSurvivalAvg: {
          //   rules: [
          //     { required: true, message: '请输入次级标准成活率!'},
          //     { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
          //   ]
          // },
          stdWeightUp: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheUpperLimitOfStandardWeight')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdWeightDown: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheLowerStandardWeightLimit')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdWeightAvg: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterStandardWeight')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          // stdEvennessUp: {
          //   rules: [
          //     { required: true, message: '请输入标准均匀度!'},
          //     { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
          //   ]
          // },
          // stdEvennessDown: {
          //   rules: [
          //     { required: true, message: '请输入标准均匀度!'},
          //     { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
          //   ]
          // },
          // stdEvennessAvg: {
          //   rules: [
          //     { required: true, message: '请输入标准均匀度!'},
          //     { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
          //   ]
          // },
          stdConsumeUp: {
            rules: [
              { required: true, message: this.$t('label.pleasEnterTheUpperLimitOfConsumptionPerUnit')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdConsumeDown: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheLowerLimitOfConsumptionPerUnit')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdConsumeAvg: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheConsumptionAmountPerUnit')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdFeedMeatUp: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheUpperLimitOfStandardMeatRatio')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdFeedMeatDown: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheLowerLimitOfStandardMeatRatio')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
          stdFeedMeatAvg: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheStandardMeatRatio')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnterANumber')},
            ]
          },
        },
        confirmLoading: false,
      }
    },
    methods:{
        planBreedQtyChange(e) {
            this.$bus.$emit('planBreedQtyChange', e)
        },
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("ContractBreedStandardForm-edit",this.model);
        let fieldval = pick(this.model,'breedCycleDays','planBreedQty','stdSurvivalUp','stdSurvivalDown','stdSurvivalAvg','stdSecSurvivalUp','stdSecSurvivalDown','stdSecSurvivalAvg','stdWeightUp','stdWeightDown','stdWeightAvg','stdEvennessUp','stdEvennessDown','stdEvennessAvg','stdConsumeUp','stdConsumeDown','stdConsumeAvg','stdFeedMeatUp','stdFeedMeatDown','stdFeedMeatAvg')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError",this.$t('tip.contractBreakdownSheetFailedTo'));
          }
        })
        console.log("合同明细表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'breedCycleDays','planBreedQty','stdSurvivalUp','stdSurvivalDown','stdSurvivalAvg','stdSecSurvivalUp','stdSecSurvivalDown','stdSecSurvivalAvg','stdWeightUp','stdWeightDown','stdWeightAvg','stdEvennessUp','stdEvennessDown','stdEvennessAvg','stdConsumeUp','stdConsumeDown','stdConsumeAvg','stdFeedMeatUp','stdFeedMeatDown','stdFeedMeatAvg'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
    }
  }
</script>
